import React, { FC } from 'react'

// TODO: replace with pixel typography props when types get included
import type { TypographyProps } from '@mui/material/Typography'
import Typography from '@pixel/core/Typography'
import { LocalizedText } from '../contexts/Localization/LocalizationTypes'
import { useLocalizedText } from '../contexts/Localization/localizationHooks'

interface LocalizedTypographyProps extends TypographyProps {
    text: LocalizedText
}
export const LocalizedTypography: FC<LocalizedTypographyProps> = ({
    text,
    ...props
}) => {
    const textValue = useLocalizedText(text)

    return (
        <Typography {...props}>{textValue}</Typography>
    )
}

export default LocalizedTypography
